export function getNodeEnv(): 'development' | 'production' | 'test' {
  return process.env.NODE_ENV;
}

export function getTranslator(): undefined | string {
  return process.env.REACT_APP_TRANSLATOR;
}
